import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=98cbdaae&scoped=true&"
import script from "./Receive.vue?vue&type=script&lang=js&"
export * from "./Receive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cbdaae",
  null
  
)

export default component.exports